var _circle, _circle2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFDE55"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00014,
    cy: 8.00002,
    r: 6.57143,
    fill: "#FFCD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.571495 10C4.67418 10 8.00007 6.67412 8.00007 2.57143C8.00007 1.67222 7.8403 0.810317 7.54759 0.0125732C3.33979 0.247146 0 3.73355 0 7.99999C0 8.68814 0.0868884 9.356 0.250288 9.99318C0.356791 9.99771 0.463876 10 0.571495 10Z",
    fill: "white",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5350_63913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.226 5.3638C11.8345 6.10764 12.1669 7.03905 12.1669 8.00005C12.1669 8.96104 11.8345 9.89245 11.226 10.6363L9.76767 9.17796C9.75638 9.16942 9.74455 9.16163 9.73225 9.15463C9.961 8.81271 10.0831 8.41059 10.0831 7.99921C10.0831 7.58784 9.961 7.18571 9.73225 6.8438C9.74455 6.8368 9.75638 6.829 9.76767 6.82046L11.226 5.3638ZM8.00017 3.83338C7.03896 3.83213 6.10715 4.16468 5.36392 4.77421L6.82225 6.23255C6.83079 6.24383 6.83859 6.25566 6.84559 6.26796C7.1875 6.03922 7.58962 5.91711 8.001 5.91711C8.41238 5.91711 8.8145 6.03922 9.15642 6.26796C9.16342 6.25566 9.17121 6.24383 9.17975 6.23255L10.6381 4.77421C9.89442 4.16432 8.96195 3.83174 8.00017 3.83338ZM8.00017 10.0834C7.58873 10.0838 7.1865 9.96165 6.84475 9.73255C6.83775 9.74485 6.82996 9.75668 6.82142 9.76796L5.36309 11.2263C6.10693 11.8347 7.03834 12.1672 7.99934 12.1672C8.96033 12.1672 9.89174 11.8347 10.6356 11.2263L9.17725 9.76796C9.16871 9.75668 9.16092 9.74485 9.15392 9.73255C8.81264 9.96134 8.41104 10.0835 8.00017 10.0834ZM3.8335 8.00005C3.83225 8.96125 4.1648 9.89307 4.77434 10.6363L6.23267 9.17796C6.24395 9.16942 6.25578 9.16163 6.26809 9.15463C6.03934 8.81271 5.91723 8.41059 5.91723 7.99921C5.91723 7.58784 6.03934 7.18571 6.26809 6.8438C6.25578 6.8368 6.24395 6.829 6.23267 6.82046L4.77434 5.36213C4.16444 6.1058 3.83187 7.03827 3.8335 8.00005Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5350_63913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.245087fe376dff3022208bbf7701025e.svg";
export { ForwardRef as ReactComponent };